// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edume-completed-all-content-heading{margin:0 0 6px;color:#5e5f61;font-size:16px;font-weight:700;line-height:20px}.edume-completed-all-content-message{color:#5e5f61;font-size:16px;font-weight:400;line-height:20px}", ""]);
// Exports
module.exports = exports;
